import React, { Dispatch } from 'react';
import {
    Button,
    Col,
    Row,
} from '@snsw/react-component-library';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { ButtonsContainer, scrollToTop, StandardAppConfig, ApplicationState, AppAction, useApplicationContext } from '../../index';

const SpacingWrapper = styled.p`
    padding-top: 1rem;
`;

const TopSpacingWrapper = styled.p`
    padding-top: .5rem;
`;

const EditButtonWrapper = styled.div`
    padding-top: 1.5rem;
    padding-bottom: .5rem;
`;

const ParagraphWrapper = styled.p`
    margin-bottom: 0rem;
`;

const HeadingWrapper = styled.h3`
    padding-top: 1rem;
    margin-bottom: .6rem;
    font-size: 22px;
`;

const BoxWrapper = styled.div`
    background: #f4f7f9;
    margin-top: 1rem;
    padding: 1.25rem;
    max-width: 769px;
    *:first-child {
        margin-top: 0;
    }
    *:last-child {
        margin-bottom: 0;
    }
    @media (max-width: 480px) {
        margin: 2rem 0;
    }
    @media print {
        border: 2px solid #dee3e5;
    }
`;

export const BankReviewPage: React.FC<{
    globalState: ApplicationState, dispatch: Dispatch<AppAction>, appConfig?: StandardAppConfig
}> = props => {
    const history = useHistory();
    const { bankDetails } = props.globalState ;

    const onSubmit = () => {
        scrollToTop();
        history.push('/review-page');
    };

    const onBack = () => {
        scrollToTop();
        history.push('/bank-details-page');
    };

    const onEdit = () => {
        scrollToTop();
        history.push('/bank-details-page');
    };

    return (
        <>
            <Row>
                <Col span={ 6 }>
                    <HeadingWrapper>
                        Confirm your bank details
                    </HeadingWrapper>
                </Col>
            </Row>
            <Row>
                <Col span={ 6 }>
                    <ParagraphWrapper>
                        Please make sure these details are correct.
                        Any errors will result in significant processing delays and may require resubmission of your application.
                    </ParagraphWrapper>
                </Col>
            </Row>
            <Row>
                <Col span={ 6 }>
                    <BoxWrapper>
                        <Row>
                            <Col span={ 4 }><TopSpacingWrapper>Account name</TopSpacingWrapper></Col>
                            <Col span={ 8 }>
                                <TopSpacingWrapper><strong>{bankDetails.accountName}</strong></TopSpacingWrapper>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={ 4 }><SpacingWrapper>BSB</SpacingWrapper></Col>
                            <Col span={ 4 }>
                                <SpacingWrapper>
                                    <strong>{bankDetails.bsb.slice(0, 3)}-{bankDetails.bsb.slice(3)}</strong>
                                </SpacingWrapper>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={ 4 }><SpacingWrapper>Account number</SpacingWrapper></Col>
                            <Col span={ 6 }><SpacingWrapper><strong>{bankDetails.accountNumber}</strong></SpacingWrapper></Col>
                        </Row>
                        <EditButtonWrapper>
                            <Button
                                variant='secondary'
                                id='editButton'
                                onClick={ onEdit }
                            >
                                Edit
                            </Button>
                        </EditButtonWrapper>
                    </BoxWrapper>
                </Col>
            </Row>
            <ButtonsContainer>
                <Button
                    className='button-item'
                    id='confirmBankButton'
                    onClick={ onSubmit }
                    data-testid='submitButton'
                >
                    Continue
                </Button>
            </ButtonsContainer>
            <Button
                id='backButton'
                onClick={ onBack }
                theme='back'
            >
                Back
            </Button>
        </>

    );
};

export const GaasBankReviewPage: React.FC = () => {
    const { globalState, dispatch } = useApplicationContext();
    return <div className='wrapper'>
        <BankReviewPage
            globalState={ globalState }
            dispatch={ dispatch }
        />
    </div>;
};
